import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Box, ListItemAvatar, alpha, styled } from "@mui/material";
import Icon from "./Icon";
import hydrateNotification from "@lib/notifications/hydrateNotification";
import moment from "moment";
import { useRouter } from "next/navigation";

const StyledListItem = styled(ListItem, { shouldForwardProp: (prop) => prop !== "unread" })(
  ({ theme, unread }) => ({
    cursor: "pointer",
    backgroundColor: unread ? alpha(theme.palette.secondary.main, 0.1) : "transparent",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  })
);

const DateItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.5rem",
}));

const IconWrapper = styled(ListItemAvatar)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  paddingLeft: "10px",
  color: theme.palette.primary.main,
}));

export default function Item({ notification, handleClose }) {
  const notificationContent = hydrateNotification(notification);
  const date = moment(notification.created_at).fromNow();
  const router = useRouter();

  return (
    <StyledListItem
      alignItems="center"
      unread={!notification.read}
      onClick={() => {
        if (notification.submission?.uuid) {
          router.push(`/submissions/${notification.submission.uuid}`);
        } else {
          router.push(`/floats/${notification.float?.uuid}`);
        }
        // Set the menu to close when a notification is clicked
        handleClose();
      }}
    >
      <IconWrapper>
        <Icon type={notification.type} />
      </IconWrapper>
      <Box sx={{ flexGrow: 1 }}>
        <ListItemText primary={notificationContent} />
        <DateItemText secondary={date} />
      </Box>
    </StyledListItem>
  );
}
